import { render } from "./NoticeBanner.vue?vue&type=template&id=ab66c754&scoped=true"
import script from "./NoticeBanner.vue?vue&type=script&lang=js"
export * from "./NoticeBanner.vue?vue&type=script&lang=js"

import "./NoticeBanner.vue?vue&type=style&index=0&id=ab66c754&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab66c754"]])

export default __exports__